export const CLASSIFICATION_TAG_FILTERS = [
  {
    attribute: 'tags.EVENEMENT',
    labelKey: 'discovery:events',
  },
  {
    attribute: 'tags.PRODUITS_DU_MONDE',
    labelKey: 'discovery:world_products',
  },
  {
    attribute: 'tags.REGIMES_ALIMENTAIRES',
    labelKey: 'discovery:diet_and_nutrition',
  },
];

export const CLASSIFICATION_TAG_SHEET_FILTERS = [
  ...CLASSIFICATION_TAG_FILTERS,
  {
    attribute: 'tags.VALEURS_ENGAGEMENTS',
    labelKey: 'discovery:values_and_commitments',
  },
  {
    attribute: 'tags.MOMENTS_CONSOMMATION',
    labelKey: 'discovery:consumption_moments',
  },
];

export const FAMILY_LEVEL_FILTERS = [
  {
    attribute: 'familyLvl3',
    labelKey: 'company:sub_family',
    depth: 2,
  },
  {
    attribute: 'familyLvl4',
    labelKey: 'company:product_nature',
    depth: 3,
  },
];

export const MAX_TAG_PILLS = 3;
